var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "scholar-search",
      style: {
        minHeight:
          _vm.$route.name === "technicalQA" ? "calc(100vh - 80px)" : "100vh",
      },
    },
    [
      _c("div", { staticClass: "content", staticStyle: { flex: "1" } }, [
        _vm.$route.name === "technicalQA" ||
        _vm.$route.name === "technicalQAGuoJiao"
          ? _c("div", { staticClass: "infor" }, [
              _c("div", [
                _vm._m(0),
                _c("p", { staticClass: "tips" }, [
                  _vm._v("用于生成概念、方法、摘要等学术类内容"),
                ]),
                _c(
                  "div",
                  { staticClass: "search-box" },
                  [_c("textareaComp", { ref: "textAreaRef" })],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "recommends-list" },
                  _vm._l(_vm.recommendData, function (item, index) {
                    return _c(
                      "p",
                      {
                        key: index,
                        staticClass: "item",
                        on: {
                          click: function ($event) {
                            return _vm.handleClickRecommend(item)
                          },
                        },
                      },
                      [
                        item.type === "2"
                          ? _c("questionIcon", {
                              attrs: {
                                width: "18",
                                height: "18",
                                fill: "#92b9ff",
                              },
                            })
                          : _vm._e(),
                        _c("span", [_vm._v(_vm._s(item.question))]),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ]),
            ])
          : _c("div", { staticClass: "history-list" }, [_c("historyChat")], 1),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "title" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/images/question/question_icon.png"),
          height: "64",
          width: "110",
        },
      }),
      _c("img", {
        staticStyle: { "margin-left": "26px" },
        attrs: {
          src: require("@/assets/images/question/question_text.png"),
          height: "43",
          width: "181",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }